import type { Frame, NoteFrame } from '../store/types';

export interface Pt { x: number; y: number }
/** Canvas-space rect of a sub-element, or null if not found. */
export type RectLookup = (frameId: string, nodeId: string) => { x: number; y: number; w: number; h: number } | null;

function frameCenter(f: Frame): Pt {
  return { x: f.x + f.w / 2, y: f.y + (f.h ?? 80) / 2 };
}

/** Resolve where a note's leader/pin should point, in canvas world coords. */
export function noteTargetPoint(note: NoteFrame, byId: Map<string, Frame>, rectLookup: RectLookup): Pt | null {
  const t = note.target;
  if (!t) return null;
  if (t.kind === 'pin') return { x: t.x, y: t.y };
  if (t.kind === 'frame') {
    const f = byId.get(t.frameId);
    return f ? frameCenter(f) : null;
  }
  // element
  const r = rectLookup(t.frameId, t.nodeId);
  if (r) return { x: r.x + r.w / 2, y: r.y + r.h / 2 };
  const f = byId.get(t.frameId);
  return f ? frameCenter(f) : null;
}
